import React, { createContext, useContext, useEffect, useMemo } from 'react';

interface ThemeContextValue {
  theme: 'light';
  toggleTheme: () => void;
  isDark: false;
}

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
    document.body.setAttribute('data-theme', 'light');
  }, []);

  const value = useMemo<ThemeContextValue>(
    () => ({ theme: 'light', toggleTheme: () => {}, isDark: false as const }),
    [],
  );

  return React.createElement(ThemeContext.Provider, { value }, children);
};

export const useTheme = (): ThemeContextValue => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
